module.exports = __webpack_public_path__ + "img/failed.43cbcb1c.svg";